import PropTypes from 'prop-types';
import { Component, createElement } from 'react';

import './Heading.scss';

export class Heading extends Component {
  render() {
    const { children, headingType, contextStyle, styleName = '' } = this.props;

    return createElement(
      headingType,
      {
        style: contextStyle,
        className: `${headingType} ${styleName}`,
      },
      children
    );
  }
}

Heading.defaultProps = {
  headingType: 'h1',
  contextStyle: {},
};

Heading.propTypes = {
  headingType: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']),
  className: PropTypes.string,
};

export default Heading;
